import type { PluginRegistry } from './PluginRegistry';

const registryMap = new Map<string, PluginRegistry>();

export const PluginRegistryMap = {
  register(key: string, registry: PluginRegistry): void {
    registryMap.set(key, registry);
  },

  get(key: string): PluginRegistry | undefined {
    return registryMap.get(key);
  },

  has(key: string): boolean {
    return registryMap.has(key);
  },

  remove(key: string): void {
    registryMap.delete(key);
  },
} as const;
